import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useOzonPaymentStatus, ozonStatusText } from './client/ozonPayment';

const statusTitles = {
  paid: 'Оплата подтверждена',
  paid_after_cancel: 'Оплата поступила после отмены заказа',
  test_paid: 'Тестовая оплата завершена',
  canceled: 'Оплата не завершена',
  pending: 'Ожидаем подтверждение оплаты',
  unavailable: 'Проверяем результат оплаты',
  review: 'Оплата требует проверки',
  not_found: 'Уточните результат оплаты',
  refunded: 'Оплата возвращена',
  partially_refunded: 'Оплата частично возвращена',
  test_refunded: 'Тестовый возврат завершён',
};

export default function PaymentReturnPage({ mobile = false }) {
  const status = useOzonPaymentStatus();
  const statusText = ozonStatusText[status];
  return <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 } }}>
    <Paper variant="outlined" sx={{ p: { xs: 3, sm: 5 }, borderRadius: 4 }}>
      <Typography color="text.secondary" gutterBottom>ПрокатПрост · Оплата</Typography>
      <Typography variant="h5" component="h1" gutterBottom>
        {statusTitles[status] || 'Результат оплаты'}
      </Typography>
      {statusText
        ? <Typography role="status" sx={{ my: 2 }}>{statusText}</Typography>
        : <Typography sx={{ my: 2 }}>
          Проверьте статус заказа в личном кабинете. Возврат на эту страницу сам по себе не подтверждает оплату или её отмену.
        </Typography>}
      {status !== 'paid' && <Typography color="text.secondary" variant="body2" sx={{ mb: 3 }}>
        Если деньги списаны, а статус ещё не изменился, не оплачивайте повторно — напишите нам в чате личного кабинета.
      </Typography>}
      <Stack spacing={2}>
        <Button variant="contained" component={Link} to="/my?tab=orders">Перейти к моим заказам</Button>
        {!mobile && <Button variant="outlined" href="prokatprost-app://payment-return">Открыть приложение</Button>}
        <Box textAlign="center"><Button component={Link} to="/">Вернуться в каталог</Button></Box>
      </Stack>
      {!mobile && <Typography variant="caption" color="text.secondary">Кнопка приложения работает после установки версии с поддержкой возврата из оплаты.</Typography>}
    </Paper>
  </Container>;
}
